import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Grid from "@mui/material/Unstable_Grid2";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import {
  Link,
  Box,
  Button,
  Tooltip,
  Switch,
  TextField,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import "./../BulkUpload.scss";
import UGTable from "../../../../../Supporting files/UGTable/UGTable";
import { ALL_ROUTES } from "../../../../../Routes/all_routes";

function BulkUploadList() {
  const navigate = useNavigate();

  const [listData, setListData] = React.useState([
    {
      rowNumber: "",
      recordID: "",
      title: "",
      name: "",
      gender: "",
      officeEmail: "",
      email: "",
      mobile: "",
      officePhone: "",
      errors: "",
    },
  ]);

  useEffect(() => {
    setListData([
      {
        rowNumber: "1",
        recordID: "PHO9R0056",
        title: "Mr.",
        name: "Rahul Raghuvanshi",
        gender: "Male",
        officeEmail: "rahul@evervent.in",
        email: "rahul@gmail.com",
        mobile: "+91 98765 43210",
        officePhone: "0161 025871",
        errors: "Duplicate records exist - Email",
      },
    ]);
  }, []);

  const updateMasterState = (attrName: any, value: any) => {
    attrName(value);
  };
  return (
    <Box className="BulklayoutWrapper">
      {/* Page header */}
      <Grid container spacing={3} className="pageHeader">
        <Grid xs={6} className="pageTitle">
          <Link
            className="backStep"
            onClick={() => {
              navigate(-1);
            }}>
            <ChevronLeftIcon />
          </Link>

          <div>
            <h3> Import Summary</h3>
          </div>
        </Grid>
      </Grid>

      <Grid container spacing={3}>
        <Grid xs={12} className="innerSection pl-10 pr-10">
          <Grid container spacing={3}>
            <Grid xs={12} className="mapfields_instructions mt-3 mb-4">
              <Grid container spacing={3} padding="0">
                <Grid xs={8}>
                  <ul className="recordViewList">
                    <li className="black_li">
                      Total records in file: <span>14</span>
                    </li>
                    <li>
                      Added: <span>1</span>
                    </li>
                    <li>
                      Updated: <span>2</span>
                    </li>
                    <li>
                      Skipped: <span>15</span>
                    </li>
                  </ul>
                </Grid>
                <Grid xs={4} textAlign="right">
                  <Link underline="none" className="blueBtn upload">
                    Export
                  </Link>
                </Grid>
              </Grid>
            </Grid>
            <Grid xs={12} padding="0">
              <div className="table">
                <div className="renewal-table2">
                  <ul className="heading">
                    <li>Row Number</li>
                    <li>Record ID</li>
                    <li>Title</li>
                    <li>Name</li>
                    <li>Gender</li>
                    <li>Office Email</li>
                    <li>Email</li>
                    <li>Mobile</li>
                    <li>Office Phone</li>
                    <li>Errors</li>
                  </ul>

                  {listData.map((data, index) => (
                    <ul className="subheading">
                      <li>
                        <p className="record_p">{data.rowNumber}</p>
                      </li>
                      <li>
                        <p className="record_p">{data.recordID}</p>
                      </li>
                      <li>
                        <p className="record_p">{data.title}</p>
                      </li>
                      <li>
                        <p className="blue_p">{data.name}</p>
                      </li>
                      <li>
                        <p className="record_p">{data.gender}</p>
                      </li>
                      <li>
                        <p className="record_p">{data.officeEmail}</p>
                      </li>
                      <li>
                        <p className="record_p">{data.email}</p>
                      </li>
                      <li>
                        <p className="record_p">{data.mobile}</p>
                      </li>
                      <li>
                        <p className="record_p">{data.officePhone}</p>
                      </li>
                      <li>
                        <p className="record_p">{data.errors}</p>
                      </li>
                    </ul>
                  ))}
                </div>
              </div>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Grid container spacing={3} className="footerSection">
        <Grid xs={12} className="ctaBtn">
          <Button
            variant="outlined"
            className="borderBtn"
            onClick={() => navigate(-4)}>
            Cancel
          </Button>
          <Button
            variant="contained"
            className="submitBtn"
            onClick={() => navigate(-4)}>
            Done
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
}

export default BulkUploadList;
